import Swal from "sweetalert2";
import store from "../store"; // Import Redux store
import { logoutUser } from "../store/auth/login/actions";

class SessionManager {
  constructor(timeout = 15 * 60 * 1000) { // Default: 15 minutes
    // constructor(timeout = 30 * 1000) { // Default: 15 minutes
    this.timeoutDuration = timeout;
    this.sessionTimeout = null;
    this.handleUserActivity = this.handleUserActivity.bind(this);
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    this.handleWindowClose = this.handleWindowClose.bind(this);
    this.checkNewSession = this.checkNewSession.bind(this);
  }

  // Start session tracking
  startSessionTracking() {
    this.resetSessionTimeout();
    window.addEventListener("mousemove", this.handleUserActivity);
    window.addEventListener("keydown", this.handleUserActivity);
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("unload", this.handleWindowClose);
    
    // Check if it's a new browser instance
    this.checkNewSession();
  }

  // Stop session tracking (cleanup)
  stopSessionTracking() {
    window.removeEventListener("mousemove", this.handleUserActivity);
    window.removeEventListener("keydown", this.handleUserActivity);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener("unload", this.handleWindowClose);
    if (this.sessionTimeout) clearTimeout(this.sessionTimeout);
  }

  // Reset session timeout on user activity
  handleUserActivity() {
    this.resetSessionTimeout();
  }

  // Logout user when session expires
  logoutUser() {
    Swal.fire({
      title: "Session Expired",
      text: "You have been inactive for too long. Logging out...",
      icon: "warning",
      timer: 5000,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      willClose: () => {
        this.clearSessionData();
        store.dispatch(logoutUser(window.history, "session_expired"));
      }
    });
  }

  // Reset session timeout timer
  resetSessionTimeout() {
    if (this.sessionTimeout) clearTimeout(this.sessionTimeout);
    this.sessionTimeout = setTimeout(() => {
      this.logoutUser();
    }, this.timeoutDuration);
  }

  // Handle before unload (Detect refresh and prevent unnecessary logout)
  handleBeforeUnload(event) {
    const isReload = performance.getEntriesByType("navigation")[0]?.type === "reload";

    if (isReload) {
      // Page refresh detected, do nothing (don't show confirmation or logout)
      return;
    }

    // Show confirmation only for tab/browser close
    event.preventDefault();
    event.returnValue = "Are you sure you want to leave? Your session will be lost.";
  }

  // Handle window close (Logout & clear session)
  handleWindowClose() {
    this.clearSessionData();
    store.dispatch(logoutUser(window.history, ""));
  }

  // Check if this is a new browser session
  checkNewSession() {
    if (!sessionStorage.getItem("session_active")) {
      // If no active session is found, clear all storage and enforce a fresh login
      this.clearSessionData();
    }
    sessionStorage.setItem("session_active", "true"); // Mark session as active
  }

  // Clear session storage and local storage
  clearSessionData() {
    sessionStorage.clear();
    // localStorage.clear();
  }
}

export default new SessionManager(); // Singleton instance
